export default "__VITE_ASSET___wHvFAb___"